import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SpecificationSelector($companyId: ID!) {
    productSpecifications(companyId: $companyId) {
      specifications 
    }
  }
`
